import { Team__Leonas } from "../teams/Leonas";
import { Team__Pumbas } from "../teams/Pumbas";
import { Team__SuperNovas } from "../teams/SuperNovas";
import { Team__Valleras } from "../teams/Valleras";
import { Team__Vaqueras } from "../teams/Vaqueras";

const Leonas = {
  team: Team__Leonas,
  playingPlayers: [
    {
      player: {
        firstName: "Julissa",
        lastName: "Arreola",
        nickName: null,
        yearBorn: 2007,
        number: null,
      },

      goals: 1,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Reyna",
        lastName: "Macario",
        nickName: null,
        yearBorn: 1990,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Elisa",
        lastName: "",
        nickName: "",
        yearBorn: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Jessica",
        lastName: "",
        nickName: "",
        yearBorn: null,
        number: null,
      },

      goals: 1,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Miranda",
        lastName: "Rodríguez",
        nickName: null,
        yearBorn: 2011,
        number: null,
      },

      goals: 0,
      fouls_commited: 1,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Johana",
        lastName: "Murillo",
        nickName: null,
        yearBorn: 2002,
        number: null,
      },

      goals: 1,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Citlali",
        lastName: "Hernández",
        nickName: null,
        yearBorn: 2007,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Julia",
        lastName: "Carbajal", // Romero
        nickName: null,
        yearBorn: 2007,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Jaqueline",
        lastName: "Arreola",
        nickName: "Jacky",
        yearBorn: 2010,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
  ],

  goals: 3,
  penaltyGoals: 0,
  isWinner: false,
};

const Pumbas = {
  team: Team__Pumbas,
  playingPlayers: [
    {
      player: {
        firstName: null,
        lastName: null,
        nickName: null,
        image: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
  ],

  goals: 2,
  penaltyGoals: 0,
  isWinner: false,
};

const SuperNovas = {
  team: Team__SuperNovas,
  playingPlayers: [
    {
      player: {
        firstName: null,
        lastName: null,
        nickName: null,
        image: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
  ],

  goals: 0,
  penaltyGoals: 0,

  isWinner: false,
};

const Valleras = {
  team: Team__Valleras,
  playingPlayers: [
    {
      player: {
        firstName: null,
        lastName: null,
        nickName: null,
        image: null,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
  ],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Vaqueras = {
  team: Team__Vaqueras,
  playingPlayers: [
    {
      player: {
        firstName: "Mayte",
        lastName: "Xalate",
        nickName: null,
        yearBorn: 2009,
        number: null,
      },

      goals: 1,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Iris",
        lastName: "Macario",
        nickName: null,
        yearBorn: 2008,
        number: null,
      },

      goals: 2,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Lucy",
        lastName: "Xalate",
        nickName: null,
        yearBorn: 2007,
        number: null,
      },

      goals: 1,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Fernanda",
        lastName: "Núñez",
        nickName: null,
        yearBorn: 2008,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Elisa",
        lastName: "Erives",
        nickName: null,
        yearBorn: 2008,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Fatima",
        lastName: "Miramontes",
        nickName: null,
        yearBorn: 2009,
        number: null,
      },

      goals: 3,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
    {
      player: {
        firstName: "Gabriela",
        lastName: "Rosario",
        nickName: "Gaby",
        yearBorn: 1991,
        number: null,
      },

      goals: 0,
      fouls_commited: 0,
      yellow_card: 0,
      red_card: 0,
    },
  ],

  goals: 7,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada5 = {
  jornadaPosition: 5,
  matches: [
    {
      team1: Vaqueras,
      team2: Leonas,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2024-08-08",
      time: "20:00:00",
      location: "Cancha Gerardo Gonzales",
    },
    {
      team1: Pumbas,
      team2: SuperNovas,

      isCompleted: true,
      isPlaying: false,
      day: "Viernes",
      date: "2024-08-09",
      time: "20:00:00",
      location: "Cancha Gerardo Gonzales",
    },
  ],
};
